import styled from "styled-components";
import { BREAKPOINTS, COLORS, TYPOGRAPHY } from "./constants";

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BG_COLOR};
  align-items: center;
  margin: 0 auto;

  @media (min-width: ${BREAKPOINTS.MD}) {
    max-width: 1366px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 60px 24px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    padding: 100px 24px;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 16px;
  gap: 16px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const FiltersGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    flex-direction: row;
  }
`;

export const FilterWrapper = styled.div`
  flex: 1;
  max-width: 100%;

  @media (min-width: ${BREAKPOINTS.MD}) {
    max-width: 288px;
  }
`;

export const FilterLabel = styled.div`
  ${TYPOGRAPHY.BODY_NORMAL_LIGHT}
  margin-bottom: 8px;
`;

export const ExportButtonWrapper = styled.div`
  display: none;

  @media (min-width: ${BREAKPOINTS.MD}) {
    display: flex;
    align-items: flex-end;
  }
`;

export const MobileExportButtonWrapper = styled.div`
  margin-top: 32px;
  display: flex;

  @media (min-width: ${BREAKPOINTS.MD}) {
    display: none;
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 10px 24px;
  border-radius: 8px;
  background-color: ${COLORS.WHITE};
  color: ${COLORS.LINK_BLUE};
  border: 1px solid ${COLORS.LINK_BLUE};
  ${TYPOGRAPHY.BODY_LARGE_BOLD}
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  text-decoration: none;

  @media (min-width: ${BREAKPOINTS.MD}) {
    width: auto;
    min-width: 200px;
    max-height: 50px;
  }

  &:hover {
    background-color: ${COLORS.LINK_BLUE_HOVER};
  }

  &[aria-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
